module.exports = __webpack_public_path__ + "img/headphones.4cf9875f.svg";